import { render, staticRenderFns } from "./ReturnOrders.vue?vue&type=template&id=3bc597c5"
import script from "./ReturnOrders.vue?vue&type=script&lang=js"
export * from "./ReturnOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports